/* Created by Interactive 63 - https://interactive63.com */
/**
 * A small modal dialog that shows a heading and a list of messages with a single Close button.
 * Used for problems that need reading rather than a passing toast.
 */
import { h } from './dom';

/** Shows the dialog and removes it when closed. A hero, such as a logo, sits above the heading. */
export function showMessageDialog(
  heading: string,
  messages: readonly (string | Node)[],
  hero?: Node,
): void {
  const dialog = h('dialog', {
    class: 'message-dialog',
    'aria-labelledby': 'message-dialog-title',
  });
  const close = h('button', { type: 'button', class: 'primary' }, 'Close');
  close.addEventListener('click', () => {
    dialog.close();
  });
  dialog.addEventListener('close', () => {
    dialog.remove();
  });
  dialog.append(
    ...(hero ? [h('div', { class: 'message-hero' }, hero)] : []),
    h('h3', { id: 'message-dialog-title' }, heading),
    h('ul', null, ...messages.map((message) => h('li', null, message))),
    h('div', { class: 'dialog-actions' }, close),
  );
  document.body.append(dialog);
  dialog.showModal();
  close.focus();
}
